import axios from 'axios';
import { settings } from '@/plugins/settings';

export const serviceProviderService = {
  /**
   * @description Returns the total count of service providers.
   */
  fetchServiceProvidersCount(): Promise<number> {
    return axios({ url: settings.endpoint + 'serviceProviders/count', method: 'GET' }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data.count || 0;
      if (response && response.data && response.data.count !== undefined) return response.data.count || 0;
      return 0;
    });
  },

  /**
   * @description Endpoint that exports data from services.
   */
  exportServiceProviders(): Promise<any[]> {
    return axios({ url: settings.endpoint + 'serviceProviders/export', method: 'GET' }).then((response: any) => {
      if (response && response.data && response.data.data) return response.data.data;
      if (response && Array.isArray(response.data)) return response.data;
      return [];
    });
  },
};
